export default __webpack_public_path__ + "static/media/hicenter_logo.6d78598e.png";